module.exports = __webpack_public_path__ + "img/thinking_fast_and_slow.9fec3c0f.png";